import { useState, useCallback, Dispatch, SetStateAction } from "react";
import { safeLocalStorage } from "client_legacy/ndaw/safeStorage";

export function useLocalStorageState<S>(
	key: string | undefined
): [S | undefined, Dispatch<SetStateAction<S>>];
export function useLocalStorageState<S>(
	key: string | undefined,
	initialState?: S | (() => S)
): [S, Dispatch<SetStateAction<S>>];
export function useLocalStorageState<S>(
	key: string | undefined,
	initialState?: S | (() => S)
): [S | undefined, Dispatch<SetStateAction<S>>] {
	const [localState, setLocalState] = useState<S>(
		(): S => {
			let state: S | nil;
			if (key) {
				state = safeLocalStorage.getItem<S>(key);
			}

			if (typeof state === "undefined" || state === null) {
				if (typeof initialState === "function") {
					state = (initialState as (() => S))();
				} else {
					state = initialState;
				}
			}

			return state as S;
		}
	);

	const setStateHandler = useCallback(
		(newState: SetStateAction<S>): void => {
			setLocalState(
				(x) => {
					let newStateValue: S;
					if (typeof newState === "function") {
						newStateValue = (newState as ((s: S) => S))(x);
					} else {
						newStateValue = newState;
					}

					if (key) {
						safeLocalStorage.setItem(key, newStateValue);
					}
					return newStateValue;
				}
			);
		},
		[key]
	);

	return [
		localState,
		setStateHandler
	];
}
